import React from 'react';
import { connect } from 'react-redux';
import Tab from './Tab';
import { setActiveTab } from '../../../../actions/individualPortal/dashboard/dashboardActionCreators';
import { useLocalStorage } from '../../../../hooks/useLocalStorage';
import { LOCAL_STORAGE } from '../../../../constants/individualPortal/dashboard/dashboardModelTypes';

const Tabs = (props) => {
    const { dashboardModels, activeTab, setActiveTab } = props;
    const { setItem } = useLocalStorage();
    const onClickHandler = (idx, appYear) => {
        setItem(LOCAL_STORAGE.ACTIVE_TAB_INDEX, idx);
        setActiveTab(idx);

        // support old jsp pages
        const coverageYearHiddenInput = document.getElementById('coverageYear');
        if (coverageYearHiddenInput) {
            coverageYearHiddenInput.value = appYear;
        }
    };

    const tabsList = dashboardModels.map((tab, idx) => (
        <Tab key={tab.applicationYear}
            onTabSelectHandler={() => onClickHandler(idx, tab.applicationYear)}
            tabData={tab}
            idx={idx}
            isActive={activeTab === idx}
        />
    ));

    return (
        <ul role="tablist" className="usa-list usa-list--unstyled grid-row gi-tabs_dashboard">
            {tabsList}
        </ul>
    );
};
const mapStateToProps = state => ({
    dashboardModels: state.individualPortal.dashboard.dashboardModels,
    activeTab: state.individualPortal.dashboard.activeTab
});

export default connect(mapStateToProps, { setActiveTab })(Tabs);
